/* eslint-disable no-param-reassign */
import api from '@utils/api'

import {
  StatusVisible,
} from '@constants/general'

export const getBusiness = (querys = {}) => async (_dispatch, _getState) => {
  if (!querys?.type) querys.type = 'all'
  const response = await api.getAllCompanies(querys)
  return response;
};
export const updateStatus = ({ id, justification, status }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (status === StatusVisible.IS_VISIBLE) validateStatus = 'suspend'
  if (status === StatusVisible.IS_HIDDEN) validateStatus = 'activate'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.updateStatusCompany(id, data)
  return response;
};

export const createNewCompany  = ({ countryId, nameCompany, clave }) => async (_dispatch, _getState) => {
  const data = {
    id_pais: countryId,
    nombre: nameCompany,
    clave
  }
  const response = await api.addCompany(data)
  return response;
};

export const editInformationCompany  = ({ companyId, nameCompany, clave, justification }) => async (_dispatch, _getState) => {
  const data = {
    id: companyId,
    nombre: nameCompany,
    clave,
    reason: justification
  }
  const response = await api.editCompany(data)
  return response;
};
